export {
  default as sauna,
  ReactComponent as Sauna,
} from '@assets/icons/features-and-amenities/sauna.svg'    
